var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconWhitetail = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.76 4.557A.571.571 0 0 0 21.201 4a.528.528 0 0 0-.528.557c0 1.327.157 5.082.2 6.381.004.292-.075.58-.228.828-.386.614-1.142 1.828-1.556 2.47-.743 1.157-1.67.857-3.013.486-1.342-.372-1.242-1.071-1.427-2.37-.229-1.556-.5-4.426-.828-7.039a.514.514 0 0 0-.529-.514.557.557 0 0 0-.457.629c-.1 2.598-.228 5.425-.285 6.938 0 1.256-.4 1.785-1.428 1.77a9.208 9.208 0 0 1-1.427-.1 1.528 1.528 0 0 1-1.428-1.242c-.214-1.142-.742-4.682-.742-4.682 0-.357-.3-.557-.543-.514-.243.042-.385.314-.385.556 0 1.428.085 3.113.1 3.984 0 1.427-.429 1.584-1.428 1.427a1.185 1.185 0 0 1-1-1.056c-.114-.486-.228-.9-.356-1.614 0-.356-.314-.485-.5-.47A.457.457 0 0 0 3 10.81v1.427a3.34 3.34 0 0 0 3.155 3.355l9.051 1.67a2.627 2.627 0 0 1 1.828 1.186c.388.761.514 1.63.357 2.47l-.129.613 3.012 1.028a5.71 5.71 0 0 0 .457-3.44c0-.214-.157-.714-.3-1.428a3.155 3.155 0 0 1 .415-2.027l1.941-3.584c.174-.281.245-.614.2-.942-.286-1.342-.942-5.154-1.228-6.581z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWhitetail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-whitetail.3879fd0f.svg";
export { ForwardRef as ReactComponent };